import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router, { stack } from './router'
import { stackedUI } from 'vue-stacked-ui'
import 'preline'

import 'vue-stacked-ui/dist/vue-stacked-ui.css'
import i18next from './i18n'
import I18NextVue from 'i18next-vue'
import { initializeSentry } from './SentryConfig'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

if (import.meta.env.MODE === 'production') {
  initializeSentry(app, router)
} else {
  console.log(`Sentry skipped due to ${import.meta.env.MODE} MODE.`)
}

app.use(pinia)
app.use(router)
app.use(stackedUI, { router: router, stack: stack })
app.use(I18NextVue, { i18next })
app.use(FloatingVue)
app.mount('#app')

// #v-ifdef DEV
// #v-ifdef VITE_TRACE_REACTIVE_TRIGGER
document.addEventListener('trace-reactive-trigger', (e) => {
  const place = e.detail.filepath.split('/').pop()! + ':' + e.detail.line
  const callee = (e.detail.watcherType ?? '') + (e.detail.watcherBind ?? '')
  const action = e.detail.event.key + '.' + e.detail.event.type
  const [newValue, oldValue] = [e.detail.event.newValue, e.detail.event.oldValue]
  const message = (() => {
    if (oldValue !== undefined && newValue !== undefined) {
      const isSame = JSON.stringify(oldValue) === JSON.stringify(newValue)
      return isSame ? 'same value!' : 'modify'
    } else {
      return '-'
    }
  })()
  console.log(`${place}\t${callee}\t${action}\tsame:${message}`)
})
// #v-endif
// #v-endif
